module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/catasto_pic_pro.df1cc989.png";